var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "700",
        persistent: "",
        "no-click-animation": "",
        scrollable: "",
        "overlay-color": "grey-500",
      },
      model: {
        value: _vm.dialogVisible,
        callback: function ($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "transparent", flat: "", height: "46" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "" },
                              on: { click: _vm.close },
                            },
                            [
                              _c("v-icon", { attrs: { size: "24" } }, [
                                _vm._v("mdi-close"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "py-5 px-5" },
            [
              _c(
                "v-alert",
                {
                  staticClass:
                    "inf-alert-yellow yellow-700--text rounded-md mb-5",
                  attrs: { dense: "", outlined: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex py-2 align-center" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "yellow-700", size: "28" } },
                        [_vm._v("mdi-alert-outline")]
                      ),
                      _c("div", { staticClass: "ml-4" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "body-1 font-weight-bold yellow-700--text",
                          },
                          [_vm._v("Atención")]
                        ),
                        _c(
                          "span",
                          { staticClass: "d-block body-2 yellow-700--text" },
                          [_vm._v(_vm._s(_vm.alertMessage))]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex align-center mb-5" },
                [
                  _c("v-icon", { attrs: { color: "grey-500", size: "24" } }, [
                    _vm._v("mdi-human-dolly"),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass:
                        "ml-2 body-1 font-weight-bold grey-500--text",
                    },
                    [
                      _vm._v(_vm._s(_vm.supplier.name || "Sin nombre")),
                      _vm.supplier.tax_id
                        ? _c("span", [
                            _vm._v(", RUT " + _vm._s(_vm.supplier.tax_id)),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "d-flex align-end" }, [
                _c(
                  "div",
                  { staticStyle: { flex: "1", "min-width": "0" } },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-2" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "grey-500", size: "18" } },
                          [_vm._v("mdi-folder")]
                        ),
                        _c(
                          "span",
                          { staticClass: "ml-2 body-2 grey-500--text" },
                          [_vm._v("Categoría actual")]
                        ),
                      ],
                      1
                    ),
                    _c("v-text-field", {
                      attrs: {
                        value: _vm.currentCategoryName,
                        outlined: "",
                        "single-line": "",
                        dense: "",
                        "hide-details": "",
                        readonly: "",
                        disabled: "",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-center align-center pb-2",
                    staticStyle: { width: "60px", "flex-shrink": "0" },
                  },
                  [
                    _c("v-icon", { attrs: { color: "grey-500", size: "28" } }, [
                      _vm._v("mdi-arrow-right-thin"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", "min-width": "0" } },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-2" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "grey-500", size: "18" } },
                          [_vm._v("mdi-folder")]
                        ),
                        _c(
                          "span",
                          { staticClass: "ml-2 body-2 grey-500--text" },
                          [_vm._v("Nueva categoría")]
                        ),
                      ],
                      1
                    ),
                    _c("v-select", {
                      attrs: {
                        "hide-details": "",
                        "single-line": "",
                        color: "green-500",
                        dense: "",
                        outlined: "",
                        items: _vm.filteredCategoriesList,
                        chips: false,
                        "item-text": "name",
                        "item-value": "id",
                        "item-disabled": "disabled",
                        placeholder: "Selecciona la nueva categoría",
                        "no-data-text": "No existen categorías para mostrar",
                        "menu-props": {
                          bottom: true,
                          offsetY: true,
                          maxHeight: 200,
                        },
                      },
                      model: {
                        value: _vm.selectedCategory,
                        callback: function ($$v) {
                          _vm.selectedCategory = $$v
                        },
                        expression: "selectedCategory",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c("span", { staticClass: "d-block grey-500--text mb-2" }, [
                    _vm._v("Escribe "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v('"confirmar"'),
                    ]),
                    _vm._v(" para continuar."),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      "single-line": "",
                      maxlength: "9",
                      "hide-details": "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        _vm.confirm.toLowerCase() === "confirmar" &&
                          _vm.handleConfirm()
                      },
                    },
                    model: {
                      value: _vm.confirm,
                      callback: function ($$v) {
                        _vm.confirm = $$v
                      },
                      expression: "confirm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "px-5 py-2" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { outlined: "" }, on: { click: _vm.close } },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "grey-900",
                    loading: _vm.loading,
                    disabled:
                      _vm.confirm.toLowerCase() !== "confirmar" ||
                      !_vm.selectedCategory,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("Confirmar")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }